import { useFetch } from './useFetch'
import type { TenantDTO } from '../types'

export function useTenant(id: string) {
  const { data: tenant, isLoading, error } =
    useFetch<TenantDTO | null>(`/v1/tenants/${id}`, null)
  return { tenant, isLoading, error }
}
